export default __webpack_public_path__ + "static/media/karachi.0d373eee.png";